/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import type { ServiceAddressCreate } from '../models/ServiceAddressCreate';
import type { ServiceAddressDetails } from '../models/ServiceAddressDetails';
import type { ServiceAddressUpdate } from '../models/ServiceAddressUpdate';
import { request as __request } from '../core/request';

export class ServiceAddressesVService {

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async serviceAddressesVGetAll(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/service_addresses/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns ServiceAddressDetails OK
     * @throws ApiError
     */
    public static async serviceAddressesVGetExport(
        requestBody?: PagingQuery,
    ): Promise<ServiceAddressDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/service_addresses/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param serviceAddressId
     * @param requestBody
     * @returns ServiceAddressDetails OK
     * @throws ApiError
     */
    public static async serviceAddressesVUpdateServiceAddress(
        serviceAddressId: string,
        requestBody?: ServiceAddressUpdate,
    ): Promise<ServiceAddressDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/service_addresses/${serviceAddressId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param serviceAddressId
     * @returns ServiceAddressDetails OK
     * @throws ApiError
     */
    public static async serviceAddressesVGetById(
        serviceAddressId: string,
    ): Promise<ServiceAddressDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/service_addresses/${serviceAddressId}`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns ServiceAddressDetails Created
     * @throws ApiError
     */
    public static async serviceAddressesVCreate(
        requestBody?: ServiceAddressCreate,
    ): Promise<ServiceAddressDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/service_addresses`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns ServiceAddressDetails Created
     * @throws ApiError
     */
    public static async serviceAddressesVCreateAll(
        requestBody?: Array<ServiceAddressCreate>,
    ): Promise<Array<ServiceAddressDetails>> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/service_addresses/bulk`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

}